module.exports = __webpack_public_path__ + "img/visa-dark_x2.2b29eeff.svg";